import React from 'react';
import { ClockIcon, LayersIcon, RefreshCwIcon, RouteIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { problems } from '../data/content';
const ICONS = {
  layers: LayersIcon,
  clock: ClockIcon,
  route: RouteIcon,
  refresh: RefreshCwIcon
};
export function ProblemSection() {
  return <section aria-labelledby="problema" className="bg-white text-brand-navy" data-id="element-139" data-mp="2vpg4g5g6n1h3">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-140" data-mp="39hcs9xatip7o">
        <p className="inline-block rounded bg-red-600 px-2 py-0.5 font-display text-[0.62rem] font-bold uppercase tracking-[0.14em] text-white" data-id="element-141" data-mp="39jqnq79eu3fr">
          ¿Te suena familiar?
        </p>
        <h2 id="problema" className="mt-1.5 font-display text-base font-extrabold leading-tight sm:text-xl" data-id="element-142" data-mp="3jdzb6gjl3672">
          Quieres tener tus clases de Matemática organizadas, pero terminas{' '}
          <span className="bg-brand-yellow px-1" data-id="element-143" data-mp="1k2xyuzouue5u">
            buscando actividades, ejercicios y evaluaciones en diferentes
            lugares.
          </span>
        </h2>
        <p className="mx-auto mt-1.5 max-w-xl text-[0.8rem] leading-snug text-slate-700" data-id="element-144" data-mp="jb0nfb52h28z">
          Si das clases en 1.º año o necesitas material para trabajar estos
          contenidos, probablemente conozcas alguna de estas situaciones:
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-145" data-mp="x4rwyjissm4p">
          {problems.map((problem, i) => {
          const Icon = ICONS[problem.icon];
          return <Reveal key={problem.title} as="li" delay={i * 0.03} className="flex h-full gap-2.5 rounded-lg border-l-4 border-red-600 bg-red-50 p-2.5 text-left" data-id="element-146" data-mp="172pj91h3k8uo" data-mpi={i}>
                <span className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-md bg-red-600" data-id="element-147" data-mp="1g2cknn9ttenq">
                  <Icon size={15} className="text-white" data-id="element-148" data-mp="3duqd86nqgnib" />
                </span>
                <div data-id="element-149" data-mp="3hvsd8pph53lc">
                  <h3 className="font-display text-[0.8rem] font-extrabold uppercase leading-tight" data-id="element-150" data-mp="3hv9520pmltki">
                    {problem.title}
                  </h3>
                  <p className="mt-0.5 text-[0.76rem] leading-snug text-slate-700" data-id="element-151" data-mp="k1z4xe5bg3rv">
                    {problem.desc}
                  </p>
                </div>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}